module.exports = __webpack_public_path__ + "img/Walnut 480x480 v2.223b9127.png";